import { render, staticRenderFns } from "./product-supplier-edit-dialog.vue?vue&type=template&id=3bd46184&"
import script from "./product-supplier-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./product-supplier-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports